<template>
  <div v-if="authData.tencentSig">
    <TUIKit :SDKAppID="1600155834" :userID="authData.onlyCode" :userSig="authData.tencentSig" />
    <TUICallKit class="callkit-container" :allowedMinimized="true" :allowedFullScreen="false" />
  </div>
</template>
<script lang="ts" setup>
import { TUIKit } from "@/TUIKit";
import { TUICallKit } from "@tencentcloud/call-uikit-vue";
import store from '@/store';
import { onMounted, ref } from 'vue';

const authData = ref(store.state.user.authData)
onMounted(() => {
  authData.value = store.state.user.authData
  if (!authData.value.tencentSig) {
    authData.value = JSON.parse(localStorage.getItem('authData') || '{}')
  }
})
</script>
<style lang="scss">
@import "@/assets/styles/index.scss";
</style>